import React from "react";

import { ReportIndicator } from "@common/reportIndicator";
import { HorizontalList } from "@common/horizontalList";
import { ReportIndicators } from "@planzone/dto";
import { Props } from "./types";
import styles from "./styles.scss";

function IndicatorsList({ indicators }: Props) {
  return (
    <HorizontalList>
      <div className={styles.indicatorsList}>
        {[...indicators]
          .sort((a, b) => (a.order < b.order ? -1 : 1))
          .map((indicator, index) => (
            <div key={index} className={styles.input}>
              <ReportIndicator
                className={styles.indicator}
                value={indicator.value as ReportIndicators}
              />
              <p className={styles.name}>{indicator.name}</p>
            </div>
          ))}
      </div>
    </HorizontalList>
  );
}

export { IndicatorsList };
